/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { PRIVATE_ROUTES } from '../../../Routes/routes'
import Button from '../../../components/Button'
import HutritGreenIcon from '../../../icons/HutritGreenIcon'
import RegisterFastIconFive from '../../../icons/RegisterFastIconFive'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useResize from '../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../utils/constants'

export const Countdown = ({
  endMessage,
  createOfferManagementMutate,
  customData,
  matchCount,
  offerId,
  id,
  getCategory,
  parseSelectedSkills,
  modalitys,
  country,
  state,
  city,
  isJuniorView = false,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const [count, setCount] = useState(5)
  const [stopCount, setStopCount] = useState(false)

  useEffect(() => {
    const defaultData = {
      ...customData,
      skillsOffer: parseSelectedSkills,
      idTalent: [id],
      position: getCategory?.name,
      IdCategorie: Number(getCategory?.id),
      modalitys: [Number(modalitys)],
      address:
        Number(modalitys?.[0]) === 3 || Number(modalitys?.[0]) === 1
          ? {
              country,
              region: state,
              city,
            }
          : null,
    }
    const juniorData = customData
    const renderSendData = isJuniorView ? juniorData : defaultData
    if (count > 0 && !stopCount) {
      const countdownInterval = setInterval(() => {
        setCount((prevCount) => prevCount - 1)
      }, 1000)

      return () => {
        clearInterval(countdownInterval)
      }
    } else if (count === 0 && !stopCount) {
      setStopCount(true)
      createOfferManagementMutate(renderSendData)
    }
  }, [count, stopCount])

  return (
    <section
      id="create-job-offer-count-down"
      className="d-flex flex-column justify-content-center align-items-center gap-5 w-100 bg-bg-primary min-heigth-100vh"
    >
      {endMessage ? (
        <div
          className={`${
            isMobile ? 'w-75' : ''
          } count-down-card d-flex flex-column justify-content-center align-items-center gap-0 bg-bg-secondary rounded shadow-sm p-lg-5 p-3`}
        >
          {!isMobile && <RegisterFastIconFive />}
          <h4 className="text-on-bg-primary fw-bolder text-center mt-4">
            {t('your_offer_was_created_successfully')}
          </h4>
          <span className="text-on-bg-primary text-center">
            {t('our_ai_tool_has_matched')}{' '}
            <strong className="text-on-bg-primary">{matchCount}</strong>{' '}
            {t('profiles_you_can_find_them_in_the_favorites_section')}
          </span>
          <div className="d-flex flex-lg-row flex-column justify-content-end align-items-center gap-3 mt-4">
            <Button
              className="btn-white text-on-bg-primary border border-on-bg-primary p-3"
              onClick={() => navigate(isJuniorView ? PRIVATE_ROUTES.list_of_offers_juniors : PRIVATE_ROUTES.list_of_offers)}
            >
              <div className="d-flex align-items-center gap-2">
                {t('back_to_offers')}
              </div>
            </Button>
            <Button
              className="btn-bg-CTA-primary text-on-bg-primary p-3"
              onClick={() => navigate(`/process/0/${offerId}`)}
            >
              {t('go_to_favorites')}
            </Button>
          </div>
        </div>
      ) : (
        <div
          className={`${
            isMobile ? 'w-75' : ''
          } count-down-card d-flex flex-column justify-content-center align-items-center gap-0 bg-bg-secondary rounded shadow-sm p-lg-5 p-3`}
        >
          {stopCount ? (
            <h1
              style={{
                fontSize: isMobile ? '52px' : '76px',
              }}
              className="text-bg-CTA-primary fw-bolder"
            >
              0
            </h1>
          ) : (
            <h1
              style={{
                fontSize: isMobile ? '52px' : '76px',
              }}
              className="text-bg-CTA-primary fw-bolder"
            >
              {count}
            </h1>
          )}
          <h4 className="text-on-bg-primary fw-bolder text-center">
            {t('we_are_creating_your_offer')}
          </h4>
          <span className="text-on-bg-primary text-center">
            {t('we_connect_the_talent_that_your_company_needs_to_measure')}
          </span>
        </div>
      )}

      <HutritGreenIcon />
    </section>
  )
}
